import { SVGInterface } from "../../interface";

const Collapse = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M20 10V8H17.41L20.5 4.91L19.09 3.5L16 6.59V4L14 4V10L20 10Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M10 4L10 10L4 10L4 8L6.59 8L3.5 4.91L4.91 3.5L8 6.59V4L10 4Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M14 20L14 14H20V16H17.41L20.5 19.09L19.09 20.5L16 17.41V20H14Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M4 16L4 14H10L10 20H8L8 17.41L4.91 20.5L3.5 19.09L6.59 16H4Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Collapse;
